$(document).ready(() => {
  $('#animate-anchor').on('click', 'a', function (event) {
    event.preventDefault();
    const id = $(this).attr('href');
    const scrollToTop = $(id).offset().top;
    $('body,html').animate({ scrollTop: scrollToTop - 65 }, 1500);
  });
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/animate-anchor.js